var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7091 52.0474C29.6868 38.2145 22.1428 29.5199 18.1236 26.9018C14.9352 13.3853 19.8221 3.33828 22.6641 0.00434161L43.3486 0.00434342C48.6358 -0.176477 49.2176 4.75095 48.8476 7.23726C51.9957 7.82494 51.5719 12.6054 50.9665 14.9222C54.8007 16.2332 53.4722 20.6295 52.3287 22.6637L53.8926 26.9018C55.3456 33.5922 41.5829 33.3059 34.5199 32.3265C37.9101 50.906 31.392 53.2153 27.7091 52.0474Z",
    fill: "#FF6969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6232 0.00463458C8.77865 7.38807 12.4704 20.5142 15.5468 26.1543L1.69773 26.1543C-1.99398 22.4626 1.185 7.18297 3.23595 0.00463323L18.6232 0.00463458Z",
    fill: "#FF6969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/failIcon.961fe00af21868d7c17e56f0648dbfd5.svg";
export { ForwardRef as ReactComponent };